import { SitecoreConfigUrl } from '../../types/generated-types';
import { assertUnreachable } from '../../utils/compiler-utils';
import { LinkItem } from './link-item-types';

export const getUrl = (
    linkItem: LinkItem,
    minsideSitecoreUrl: string,
    glasskadeVerkstedSitecoreUrl: string,
): string => {
    switch (linkItem.link.urlType) {
        case 'SitecoreLink':
            switch (linkItem.link.configUrl) {
                case SitecoreConfigUrl.MinSide:
                    return minsideSitecoreUrl;
                case SitecoreConfigUrl.VerkstedGlasskade:
                    return glasskadeVerkstedSitecoreUrl;
                default:
                    return assertUnreachable(linkItem.link.configUrl);
            }
        case 'InternalLink':
            return linkItem.link.url;
        case 'ExternalLink':
            return linkItem.link.url;
        default:
            return assertUnreachable(linkItem.link);
    }
};
